// ------ -plugin import -------- //
import React, { useState } from 'react'
import { useParams } from "react-router-dom";

// ------- component import -------- //
import { PageTitle } from "../../../../_template/layout/core/PageData";
import BillingInfo from './component/BillingInfo';
import CreditReport from './component/CreditReport';

const Billing = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');
    const pageTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    // ------ define all state here ------ //
    const [isCreditAdded, setIsCreditAdded] = useState(false);

    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>Billing</PageTitle>
            <BillingInfo
                creditAdded={(value) => setIsCreditAdded(value)}
            />
            <CreditReport 
                isCreditAdded={isCreditAdded}
            />
        </>
    )
}
export default Billing